<script setup lang="ts">
/**
 * Cadre de téléphone des pages charte « apple » (Karim 2026-10-18) : bord
 * noir fin et régulier, coins concentriques. Mesures en cqw = % de la
 * LARGEUR DU TÉLÉPHONE (un % de padding se calculerait sur le parent → bord
 * trop épais, signalé par Karim). Arrondi de l'écran = arrondi du cadre −
 * épaisseur du bord. La largeur se règle sur le composant (classe/style).
 */
const props = withDefaults(
  defineProps<{
    image: string;
    largeur: number;
    hauteur: number;
    alt: string;
    sizes?: string;
    /** Image prioritaire (haut de page, visible au chargement). */
    prioritaire?: boolean;
  }>(),
  { sizes: "xs:110px sm:160px md:200px lg:230px", prioritaire: false },
);
</script>

<template>
  <div class="telephone-apple">
    <div class="telephone-cadre">
      <NuxtImg
        :src="props.image"
        :alt="props.alt"
        :width="props.largeur"
        :height="props.hauteur"
        :sizes="props.sizes"
        :loading="props.prioritaire ? 'eager' : 'lazy'"
        :fetchpriority="props.prioritaire ? 'high' : undefined"
        class="telephone-image"
        :style="{ aspectRatio: `${props.largeur} / ${props.hauteur}` }"
      />
    </div>
  </div>
</template>

<style scoped>
.telephone-apple {
  container-type: inline-size;
}
.telephone-cadre {
  padding: 3.6cqw;
  border-radius: 15cqw;
  background: #1d1d1f;
  box-shadow:
    inset 0 0 0 0.6cqw #3a3a3c,
    0 30px 60px -20px rgba(0, 0, 0, 0.45);
}
.telephone-image {
  display: block;
  width: 100%;
  height: auto;
  object-fit: cover;
  object-position: top;
  border-radius: 11.4cqw;
  background: #000;
}
</style>
